import { Injectable } from '@angular/core';
import { StorageBaseService } from '@app/core/storage/storage-base.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService extends StorageBaseService {
    protected storage: Storage = localStorage;
}
